import Vue from 'vue'
import Router from 'vue-router'
import Splash from '@/templates/comp/splash'
import OverviewArrivals from '@/templates/comp/overview-arrivals'
import OverviewBookings from '@/templates/comp/overview-bookings'
import OverviewGraphs from '@/templates/comp/overview-graphs'
import BookingsHome from '@/templates/comp/bookings-home'
import ReservationEdit from '@/templates/comp/reservation-edit'
import BlocationEdit from '@/templates/comp/blocation-edit'
import CurrentRoomEdit from '@/templates/comp/current-room-edit'
import BookingsChannel from '@/templates/comp/bookings-channel'
import BookingsCalendar from '@/templates/comp/bookings-calendar'
import BookingsOverview from '@/templates/comp/bookings-overview'
import GuestsHome from '@/templates/comp/guests-home'
import CheckinHome from '@/templates/comp/checkin-home'
import CheckinNew from '@/templates/comp/checkin-new'
import SettingsMain from '@/templates/comp/settings-main'
import SettingsChartType from '@/templates/comp/settings-chart-type'
import SettingsChartRange from '@/templates/comp/settings-chart-range'
import SettingsPriceMask from '@/templates/comp/settings-price-mask'
import Search from '@/templates/comp/search'
import Logout from '@/templates/comp/logout'
import OverviewGraph from '@/templates/comp/overview-graph';
import OverviewOccupancy from '@/templates/comp/overview-occupancy';
import OverviewReservationsPage from '@/templates/comp/overview-reservations-page';
import OverviewHomeNew from '../templates/comp/overview-home-new';
import GuestsDepartures from '../templates/comp/guests-departures.vue';
import RoomGraph from '../templates/comp/room-graph.vue';
import CheckinEdit from '../templates/comp/checkin-edit.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Splash,
            meta: {
                splash: true,
                headerSub: false
            }
        },
        {
            path: '/overview',
            name: 'Overview',

            component: OverviewHomeNew,
            meta: {
                headerSub: false,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/occupancy',
            name: 'Overview occupancy',
            component: OverviewOccupancy,
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/reservations',
            name: 'Overview Reservations',
            component: OverviewReservationsPage,
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/graph/adr',
            name: 'Overview ADR',
            component: OverviewGraph,
            props: {
                label: 'ADR',
                field: 'adr'
            },
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/graph/trzby',
            name: 'Overview Trzby',
            component: OverviewGraph,
            props: {
                label: 'earnings',
                translate:true,
                field: 'revenue'
            },
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/graph/revpar',
            name: 'Overview RevPAR',
            component: OverviewGraph,
            props: {
                label: 'RevPAR',
                field: 'rev_par'
            },
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/graph/alos',
            name: 'Overview ALoS',
            component: OverviewGraph,
            props: {
                label: 'ALoS',
                field: 'alos'
            },
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/graph/booking_window',
            name: 'Overview Booking Window',
            component: OverviewGraph,
            props: {
                label: 'Booking Window',
                field: 'booking_window'
            },
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/arrivals',
            name: 'Arrivals',
            component: OverviewArrivals,
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/arrivals/:id/:row/:roomId?/:subScreen?/:subScreenItemId?',
            name: 'Edit checkin',
            component: CheckinEdit,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/overview/departures',
            name: 'Departures',
            component: GuestsDepartures/*OverviewDepartures*/,
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/bookings',
            name: 'Bookings Overview',
            component: OverviewBookings,
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/graphs',
            name: 'Graphs',
            component: OverviewGraphs,
            meta: {
                headerSub: false,
                transitionSlide: true,
            }
        },
        {
            path: '/overview/guests',
            name: 'Overview Guests',
            component: GuestsHome,
            meta: {
                headerSub: true,
                transitionSlide: true,
            }
        },
        {
            path: '/room-graph',
            name: 'Room Graph',

            component: RoomGraph,
            meta: {
                headerSub: false,
                transitionSlide: true,
            }
        },
        {
            path: '/bookings',
            name: 'Bookings',
            component: BookingsHome,
            meta: {
                headerSub: false
            }
        },
        {
            path: '/bookings/new/:subScreen?',
            name: 'New booking',
            component: ReservationEdit,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/bookings/edit/:id/:row/:subScreen?/:subScreenItemId?',
            name: 'Edit booking',
            component: ReservationEdit,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/bookings/overview',
            name: 'Bookings Overview 2',
            component: BookingsOverview,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/blocation/edit/:roomId/:date',
            name: 'Edit blocation',
            component: BlocationEdit,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/guests/edit/:roomId/:subScreen?/:subScreenItemId?',
            name: 'Edit current room',
            component: CurrentRoomEdit,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/bookings/channel',
            name: 'Channel Manager',
            component: BookingsChannel,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/bookings/calendar',
            name: 'Channel Manager Calendar',
            component: BookingsCalendar,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/guests',
            name: 'Guests',
            component: GuestsHome,
            meta: {
                headerSub: false
            }
        },
        {
            path: '/check-in',
            name: 'Check-in',
            component: CheckinHome,
            meta: {
                headerSub: false
            }
        },
        {
            path: '/check-in/new',
            name: 'Nový Check-in',
            component: CheckinNew,
            meta: {
                headerSub: false
            }
        },
        {
            path: '/settings',
            name: 'Settings',
            component: SettingsMain,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/settings/chart/type/:chart',
            name: 'Chart Type Settings',
            component: SettingsChartType,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/settings/chart/range/:chart',
            name: 'Chart Range Settings',
            component: SettingsChartRange,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/settings/price-mask',
            name: 'Price Mask Settings',
            component: SettingsPriceMask,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/search',
            name: 'Search',
            component: Search,
            meta: {
                headerSub: true
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta: {
                headerSub: false
            }
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js